"use client"

import ProductDetailsPrice from "~/components/ui/ProductHeader/components/ProductDetails/components/ProductDetailsPrice"
import type { ProductDetailsPriceWithVariantSwitchProps } from "~/app/[locale]/products/[slug]/(components)/ProductDetailsPriceWithVariantSwitch"
import { useVariantSwitch } from "~/app/[locale]/products/[slug]/(hooks)/useVariantSwitch"

function ClientProductDetailsPriceWithVariantSwitch({
  className,
  variants,
  defaultVariant,
}: ProductDetailsPriceWithVariantSwitchProps) {
  const { priceVariant } = useVariantSwitch({ variants, defaultVariant })

  if (!priceVariant) return null

  return <ProductDetailsPrice className={className} {...priceVariant} />
}

export default ClientProductDetailsPriceWithVariantSwitch
